/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface SimulatorService {
  /**
   * @summary Simulate
   * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
   * office, read-only/dry-run, and return the per-step decision trace + route funnel.
   */
  simulateAdminSimulatorSimulatePost: {
    /**
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SimulateAdminSimulatorSimulatePostBody,
        SimulateAdminSimulatorSimulatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SimulateAdminSimulatorSimulatePostSchema,
        options: ServiceOperationMutationFnOptions<
          SimulateAdminSimulatorSimulatePostBody,
          SimulateAdminSimulatorSimulatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SimulateAdminSimulatorSimulatePostData, SimulateAdminSimulatorSimulatePostError>>
    ): Promise<RequestFnResponse<SimulateAdminSimulatorSimulatePostData, SimulateAdminSimulatorSimulatePostError>>;
    /**
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     */
    getMutationKey(
      parameters: DeepReadonly<SimulateAdminSimulatorSimulatePostParameters> | void
    ): ServiceOperationMutationKey<
      SimulateAdminSimulatorSimulatePostSchema,
      SimulateAdminSimulatorSimulatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SimulateAdminSimulatorSimulatePostBody, TContext = unknown>(
      parameters: DeepReadonly<SimulateAdminSimulatorSimulatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SimulateAdminSimulatorSimulatePostSchema,
        SimulateAdminSimulatorSimulatePostData,
        SimulateAdminSimulatorSimulatePostParameters,
        TVariables,
        OperationError<SimulateAdminSimulatorSimulatePostError>,
        TContext
      >
    ): UseMutationResult<
      SimulateAdminSimulatorSimulatePostData,
      OperationError<SimulateAdminSimulatorSimulatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SimulateAdminSimulatorSimulatePostBody,
        SimulateAdminSimulatorSimulatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SimulateAdminSimulatorSimulatePostSchema,
        SimulateAdminSimulatorSimulatePostData,
        SimulateAdminSimulatorSimulatePostParameters,
        TVariables,
        OperationError<SimulateAdminSimulatorSimulatePostError>,
        TContext
      >
    ): UseMutationResult<
      SimulateAdminSimulatorSimulatePostData,
      OperationError<SimulateAdminSimulatorSimulatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const simulateAdminSimulatorSimulatePostTotal = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const simulateAdminSimulatorSimulatePostTotal = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SimulateAdminSimulatorSimulatePostSchema,
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const simulateAdminSimulatorSimulatePostPendingMutationVariables = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const simulateAdminSimulatorSimulatePostMutationData = qraft.simulatorService.simulateAdminSimulatorSimulatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SimulateAdminSimulatorSimulatePostData,
        OperationError<SimulateAdminSimulatorSimulatePostError>,
        MutationVariables<SimulateAdminSimulatorSimulatePostBody, SimulateAdminSimulatorSimulatePostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SimulateAdminSimulatorSimulatePostSchema,
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SimulateAdminSimulatorSimulatePostData,
          OperationError<SimulateAdminSimulatorSimulatePostError>,
          MutationVariables<SimulateAdminSimulatorSimulatePostBody, SimulateAdminSimulatorSimulatePostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SimulateAdminSimulatorSimulatePostSchema,
            SimulateAdminSimulatorSimulatePostBody,
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostParameters,
            OperationError<SimulateAdminSimulatorSimulatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Simulate
     * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
     * office, read-only/dry-run, and return the per-step decision trace + route funnel.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.simulatorService.simulateAdminSimulatorSimulatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.simulatorService.simulateAdminSimulatorSimulatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SimulateAdminSimulatorSimulatePostBody,
              SimulateAdminSimulatorSimulatePostData,
              SimulateAdminSimulatorSimulatePostParameters,
              OperationError<SimulateAdminSimulatorSimulatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SimulateAdminSimulatorSimulatePostSchema,
              SimulateAdminSimulatorSimulatePostBody,
              SimulateAdminSimulatorSimulatePostData,
              SimulateAdminSimulatorSimulatePostParameters,
              OperationError<SimulateAdminSimulatorSimulatePostError>,
              TContext
            >
      ):
        | Mutation<
            SimulateAdminSimulatorSimulatePostData,
            SimulateAdminSimulatorSimulatePostError,
            MutationVariables<SimulateAdminSimulatorSimulatePostBody, SimulateAdminSimulatorSimulatePostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SimulateAdminSimulatorSimulatePostBody,
              SimulateAdminSimulatorSimulatePostData,
              SimulateAdminSimulatorSimulatePostParameters,
              OperationError<SimulateAdminSimulatorSimulatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SimulateAdminSimulatorSimulatePostSchema,
              SimulateAdminSimulatorSimulatePostBody,
              SimulateAdminSimulatorSimulatePostData,
              SimulateAdminSimulatorSimulatePostParameters,
              OperationError<SimulateAdminSimulatorSimulatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          SimulateAdminSimulatorSimulatePostData,
          SimulateAdminSimulatorSimulatePostError,
          MutationVariables<SimulateAdminSimulatorSimulatePostBody, SimulateAdminSimulatorSimulatePostParameters>,
          TContext
        >
      >;
    };
    schema: SimulateAdminSimulatorSimulatePostSchema;
    types: {
      parameters: SimulateAdminSimulatorSimulatePostParameters;
      data: SimulateAdminSimulatorSimulatePostData;
      error: SimulateAdminSimulatorSimulatePostError;
      body: SimulateAdminSimulatorSimulatePostBody;
    };
  };
  /**
   * @summary Office Profile
   * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
   */
  officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet: {
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        options: {
          parameters: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    >;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getQueryKey(
      parameters: DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
    ): ServiceOperationQueryKey<
      OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
      OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
      OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
      TQueryFnData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
      TQueryFnData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetTotal = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetByParametersTotal = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetResults = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetCombinedResults = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
      TData = OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError,
          OperationInfiniteData<TData, OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
          ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>,
      OperationError<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetCombinedData = qraft.simulatorService.officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    fetchInfiniteQuery<TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        DeepReadonly<TPageParam>,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
      >
    >;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    prefetchInfiniteQuery<TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        DeepReadonly<TPageParam>,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    ensureInfiniteQueryData<TPageParam extends OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        DeepReadonly<TPageParam>,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
      >
    >;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
    ): OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
    ):
      | OperationInfiniteData<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
        >
      | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
                    OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
            >,
            data: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData | undefined,
          ]
        >;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
    ):
      | QueryState<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
        >
      | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    setQueryData(
      parameters:
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
        | ServiceOperationQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
      updater: Updater<
        NoInfer<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData> | undefined,
        NoInfer<DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData>> | undefined
      >,
      options?: SetDataOptions
    ): OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
              OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
                OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
          OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters
        >
      | undefined;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >,
      updater: Updater<
        NoInfer<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData> | undefined,
        NoInfer<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData | undefined>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
        TInfinite,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
        OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
    ): void;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Office Profile
     * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
        | QueryFiltersByQueryKey<
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData,
            TInfinite,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters,
            OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError
          >
    ): number;
    schema: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema;
    types: {
      parameters: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters;
      data: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData;
      error: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError;
    };
  };
  /**
   * @summary Replay Call
   * @description Load a recorded call's tool sequence (for replay under current clock + data).
   */
  replayCallAdminSimulatorSimulateReplayCallIdGet: {
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        options: {
          parameters: ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    >;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getQueryKey(
      parameters: DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
    ): ServiceOperationQueryKey<
      ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
      ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useQuery({
     *     path: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useQuery<TData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useQuery({
     *     path: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useQuery<TData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
      ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useInfiniteQuery({
     *     path: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
      TQueryFnData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useInfiniteQuery({
     *     path: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
      TQueryFnData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetTotal = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetByParametersTotal = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             call_id: callId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetResults = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             path: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * replayCallAdminSimulatorSimulateReplayCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetCombinedResults = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             path: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * replayCallAdminSimulatorSimulateReplayCallIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useSuspenseQuery({
     *     path: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
      TData = ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError,
          OperationInfiniteData<TData, ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>,
      OperationError<ReplayCallAdminSimulatorSimulateReplayCallIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetData = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             path: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * replayCallAdminSimulatorSimulateReplayCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const replayCallAdminSimulatorSimulateReplayCallIdGetCombinedData = qraft.simulatorService.replayCallAdminSimulatorSimulateReplayCallIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             path: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * replayCallAdminSimulatorSimulateReplayCallIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
              ReplayCallAdminSimulatorSimulateReplayCallIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<ReplayCallAdminSimulatorSimulateReplayCallIdGetData>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<ReplayCallAdminSimulatorSimulateReplayCallIdGetData>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    fetchInfiniteQuery<TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        DeepReadonly<TPageParam>,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
      >
    >;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    prefetchInfiniteQuery<TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        DeepReadonly<TPageParam>,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    ensureInfiniteQueryData<TPageParam extends ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        DeepReadonly<TPageParam>,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
      >
    >;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
    ): ReplayCallAdminSimulatorSimulateReplayCallIdGetData | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
    ):
      | OperationInfiniteData<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
              ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
                    ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
              ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
            >,
            data: ReplayCallAdminSimulatorSimulateReplayCallIdGetData | undefined,
          ]
        >;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
    ):
      | QueryState<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetError
        >
      | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    setQueryData(
      parameters:
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
        | ServiceOperationQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
      updater: Updater<
        NoInfer<ReplayCallAdminSimulatorSimulateReplayCallIdGetData> | undefined,
        NoInfer<DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ReplayCallAdminSimulatorSimulateReplayCallIdGetData | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
              ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
                ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
          ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >,
      updater: Updater<
        NoInfer<ReplayCallAdminSimulatorSimulateReplayCallIdGetData> | undefined,
        NoInfer<ReplayCallAdminSimulatorSimulateReplayCallIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ReplayCallAdminSimulatorSimulateReplayCallIdGetData | undefined>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
        TInfinite,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
        ReplayCallAdminSimulatorSimulateReplayCallIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
    ): void;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Replay Call
     * @description Load a recorded call's tool sequence (for replay under current clock + data).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
        | QueryFiltersByQueryKey<
            ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetData,
            TInfinite,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters,
            ReplayCallAdminSimulatorSimulateReplayCallIdGetError
          >
    ): number;
    schema: ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema;
    types: {
      parameters: ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters;
      data: ReplayCallAdminSimulatorSimulateReplayCallIdGetData;
      error: ReplayCallAdminSimulatorSimulateReplayCallIdGetError;
    };
  };
  /**
   * @summary Office Customers
   * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
   *
   * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
   * office); super-admin only, like every simulator route. Read-only.
   */
  officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet: {
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        options: {
          parameters: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    >;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getQueryKey(
      parameters: DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
    ): ServiceOperationQueryKey<
      OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
      OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         q: q
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         q: q
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>
    >;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
      OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             q: initialQ
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
      TQueryFnData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             q: initialQ
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
      TQueryFnData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetTotal = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetByParametersTotal = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         },
     *         query: {
     *             q: q
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetResults = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 q: q1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 q: q2
     *             }
     *         }
     *     ]
     * });
     * officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetCombinedResults = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 q: q1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 q: q2
     *             }
     *         }
     *     ]
     * });
     * officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         q: q
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             q: initialQ
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
      TData = OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError,
          OperationInfiniteData<TData, OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
          ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>,
      OperationError<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 q: q1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 q: q2
     *             }
     *         }
     *     ]
     * });
     * officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetCombinedData = qraft.simulatorService.officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 q: q1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 q: q2
     *             }
     *         }
     *     ]
     * });
     * officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    fetchInfiniteQuery<TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        DeepReadonly<TPageParam>,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
      >
    >;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    prefetchInfiniteQuery<TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        DeepReadonly<TPageParam>,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    ensureInfiniteQueryData<
      TPageParam extends OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        DeepReadonly<TPageParam>,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
      >
    >;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
    ): OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
    ):
      | OperationInfiniteData<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
        >
      | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
                    OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
            >,
            data: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData | undefined,
          ]
        >;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
    ):
      | QueryState<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
        >
      | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    setQueryData(
      parameters:
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
        | ServiceOperationQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
      updater: Updater<
        NoInfer<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData> | undefined,
        NoInfer<DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData>> | undefined
      >,
      options?: SetDataOptions
    ): OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
              OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
                OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
          OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters
        >
      | undefined;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >,
      updater: Updater<
        NoInfer<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData> | undefined,
        NoInfer<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData | undefined>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
        TInfinite,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
        OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
    ): void;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Office Customers
     * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
     *
     * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
     * office); super-admin only, like every simulator route. Read-only.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
        | QueryFiltersByQueryKey<
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData,
            TInfinite,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters,
            OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError
          >
    ): number;
    schema: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema;
    types: {
      parameters: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters;
      data: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData;
      error: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError;
    };
  };
  /**
   * @summary Office Service Types
   * @description Bookable services for the dependent service-type picker: the office's active
   * service-type templates (the voice catalog) + the customer's own service types.
   * Super-admin only; read-only.
   */
  officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet: {
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        options: {
          parameters: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    >;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getQueryKey(
      parameters: DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
    ): ServiceOperationQueryKey<
      OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
      OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<
      TData,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
      OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
      TQueryFnData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
      TQueryFnData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetTotal = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetByParametersTotal = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         },
     *         query: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetResults = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetCombinedResults = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     },
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          TData,
          ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
      TData = OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError,
          OperationInfiniteData<TData, OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>,
      OperationError<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetCombinedData = qraft.simulatorService.officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             },
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             },
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    fetchInfiniteQuery<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        DeepReadonly<TPageParam>,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
      >
    >;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    prefetchInfiniteQuery<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        DeepReadonly<TPageParam>,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    ensureInfiniteQueryData<
      TPageParam extends OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        DeepReadonly<TPageParam>,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >
    ): Promise<
      OperationInfiniteData<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
      >
    >;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
    ): OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
    ):
      | OperationInfiniteData<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
        >
      | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
                    OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
            >,
            data: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData | undefined,
          ]
        >;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
    ):
      | QueryState<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
        >
      | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    setQueryData(
      parameters:
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
        | ServiceOperationQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
      updater: Updater<
        NoInfer<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData> | undefined,
        NoInfer<DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
              OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
                OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
          OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters
        >
      | undefined;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >,
      updater: Updater<
        NoInfer<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData> | undefined,
        NoInfer<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData | undefined>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
        TInfinite,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
        OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
    ): void;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Office Service Types
     * @description Bookable services for the dependent service-type picker: the office's active
     * service-type templates (the voice catalog) + the customer's own service types.
     * Super-admin only; read-only.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
        | QueryFiltersByQueryKey<
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData,
            TInfinite,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters,
            OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError
          >
    ): number;
    schema: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema;
    types: {
      parameters: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters;
      data: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData;
      error: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError;
    };
  };
  /**
   * @summary Persisted Traces
   * @description List the office's persisted live-call traces (FEAT-029), newest first.
   *
   * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
   * techs/routes were dropped despite an offer). Super-admin only; read-only.
   */
  persistedTracesAdminSimulatorSimulateTracesGet: {
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<PersistedTracesAdminSimulatorSimulateTracesGetParameters, TMeta, TSignal>,
      client?: (
        schema: PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        options: {
          parameters: PersistedTracesAdminSimulatorSimulateTracesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    >;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getQueryKey(
      parameters: DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
    ): ServiceOperationQueryKey<
      PersistedTracesAdminSimulatorSimulateTracesGetSchema,
      PersistedTracesAdminSimulatorSimulateTracesGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = PersistedTracesAdminSimulatorSimulateTracesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = PersistedTracesAdminSimulatorSimulateTracesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      PersistedTracesAdminSimulatorSimulateTracesGetSchema,
      PersistedTracesAdminSimulatorSimulateTracesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters,
      TQueryFnData = PersistedTracesAdminSimulatorSimulateTracesGetData,
      TData = OperationInfiniteData<TQueryFnData, PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters,
      TQueryFnData = PersistedTracesAdminSimulatorSimulateTracesGetData,
      TData = OperationInfiniteData<TQueryFnData, PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetTotal = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetByParametersTotal = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetResults = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * persistedTracesAdminSimulatorSimulateTracesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetCombinedResults = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * persistedTracesAdminSimulatorSimulateTracesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          PersistedTracesAdminSimulatorSimulateTracesGetSchema,
          PersistedTracesAdminSimulatorSimulateTracesGetParameters,
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = PersistedTracesAdminSimulatorSimulateTracesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useSuspenseInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters,
      TData = PersistedTracesAdminSimulatorSimulateTracesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError,
          OperationInfiniteData<TData, PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, PersistedTracesAdminSimulatorSimulateTracesGetParameters>,
      OperationError<PersistedTracesAdminSimulatorSimulateTracesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetData = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * persistedTracesAdminSimulatorSimulateTracesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const persistedTracesAdminSimulatorSimulateTracesGetCombinedData = qraft.simulatorService.persistedTracesAdminSimulatorSimulateTracesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * persistedTracesAdminSimulatorSimulateTracesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          PersistedTracesAdminSimulatorSimulateTracesGetSchema,
          PersistedTracesAdminSimulatorSimulateTracesGetParameters,
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              PersistedTracesAdminSimulatorSimulateTracesGetData,
              PersistedTracesAdminSimulatorSimulateTracesGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<PersistedTracesAdminSimulatorSimulateTracesGetData>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<PersistedTracesAdminSimulatorSimulateTracesGetData>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    fetchInfiniteQuery<TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<
      OperationInfiniteData<
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters
      >
    >;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    prefetchInfiniteQuery<TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    ensureInfiniteQueryData<TPageParam extends PersistedTracesAdminSimulatorSimulateTracesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >
    ): Promise<
      OperationInfiniteData<
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters
      >
    >;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
    ): PersistedTracesAdminSimulatorSimulateTracesGetData | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
    ):
      | OperationInfiniteData<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetParameters
        >
      | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              PersistedTracesAdminSimulatorSimulateTracesGetSchema,
              PersistedTracesAdminSimulatorSimulateTracesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    PersistedTracesAdminSimulatorSimulateTracesGetData,
                    PersistedTracesAdminSimulatorSimulateTracesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              PersistedTracesAdminSimulatorSimulateTracesGetSchema,
              PersistedTracesAdminSimulatorSimulateTracesGetParameters
            >,
            data: PersistedTracesAdminSimulatorSimulateTracesGetData | undefined,
          ]
        >;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
    ):
      | QueryState<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
          PersistedTracesAdminSimulatorSimulateTracesGetError
        >
      | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    setQueryData(
      parameters:
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
        | ServiceOperationQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
      updater: Updater<
        NoInfer<PersistedTracesAdminSimulatorSimulateTracesGetData> | undefined,
        NoInfer<DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): PersistedTracesAdminSimulatorSimulateTracesGetData | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<PersistedTracesAdminSimulatorSimulateTracesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              PersistedTracesAdminSimulatorSimulateTracesGetData,
              PersistedTracesAdminSimulatorSimulateTracesGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                PersistedTracesAdminSimulatorSimulateTracesGetData,
                PersistedTracesAdminSimulatorSimulateTracesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          PersistedTracesAdminSimulatorSimulateTracesGetData,
          PersistedTracesAdminSimulatorSimulateTracesGetParameters
        >
      | undefined;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >,
      updater: Updater<
        NoInfer<PersistedTracesAdminSimulatorSimulateTracesGetData> | undefined,
        NoInfer<PersistedTracesAdminSimulatorSimulateTracesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<PersistedTracesAdminSimulatorSimulateTracesGetData | undefined>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        PersistedTracesAdminSimulatorSimulateTracesGetSchema,
        PersistedTracesAdminSimulatorSimulateTracesGetData,
        TInfinite,
        PersistedTracesAdminSimulatorSimulateTracesGetParameters,
        PersistedTracesAdminSimulatorSimulateTracesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
    ): void;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Persisted Traces
     * @description List the office's persisted live-call traces (FEAT-029), newest first.
     *
     * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
     * techs/routes were dropped despite an offer). Super-admin only; read-only.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTracesAdminSimulatorSimulateTracesGetSchema,
            PersistedTracesAdminSimulatorSimulateTracesGetData,
            TInfinite,
            PersistedTracesAdminSimulatorSimulateTracesGetParameters,
            PersistedTracesAdminSimulatorSimulateTracesGetError
          >
    ): number;
    schema: PersistedTracesAdminSimulatorSimulateTracesGetSchema;
    types: {
      parameters: PersistedTracesAdminSimulatorSimulateTracesGetParameters;
      data: PersistedTracesAdminSimulatorSimulateTracesGetData;
      error: PersistedTracesAdminSimulatorSimulateTracesGetError;
    };
  };
  /**
   * @summary Persisted Trace Detail
   * @description One persisted trace with its full decision path, labeled for the simulator UI.
   *
   * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
   * (empty for playground / failed-registration traces). Super-admin only; read-only.
   */
  persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet: {
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        options: {
          parameters: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    >;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getQueryKey(
      parameters: DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
    ): ServiceOperationQueryKey<
      PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
      PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * })
     * ```
     */
    useQuery<TData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * })
     * ```
     */
    useQuery<TData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
      PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useInfiniteQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
      TQueryFnData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
      TData = OperationInfiniteData<TQueryFnData, PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useInfiniteQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
      TQueryFnData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
      TData = OperationInfiniteData<TQueryFnData, PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetTotal = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetByParametersTotal = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             trace_id: traceId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetResults = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 trace_id: traceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trace_id: traceId2
     *             }
     *         }
     *     ]
     * });
     * persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetCombinedResults = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 trace_id: traceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trace_id: traceId2
     *             }
     *         }
     *     ]
     * });
     * persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useSuspenseQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          TData,
          ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         trace_id: traceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
      TData = PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError,
          OperationInfiniteData<TData, PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>,
      OperationError<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 trace_id: traceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trace_id: traceId2
     *             }
     *         }
     *     ]
     * });
     * persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetCombinedData = qraft.simulatorService.persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 trace_id: traceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 trace_id: traceId2
     *             }
     *         }
     *     ]
     * });
     * persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    fetchInfiniteQuery<TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
      >
    >;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    prefetchInfiniteQuery<TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    ensureInfiniteQueryData<TPageParam extends PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        DeepReadonly<TPageParam>,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
      >
    >;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
    ): PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
    ):
      | OperationInfiniteData<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
        >
      | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
                    PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
            >,
            data: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData | undefined,
          ]
        >;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
    ):
      | QueryState<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
        >
      | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    setQueryData(
      parameters:
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
        | ServiceOperationQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
      updater: Updater<
        NoInfer<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData> | undefined,
        NoInfer<DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
              PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
                PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
          PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters
        >
      | undefined;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >,
      updater: Updater<
        NoInfer<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData> | undefined,
        NoInfer<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData | undefined>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
        TInfinite,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
        PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
    ): void;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Persisted Trace Detail
     * @description One persisted trace with its full decision path, labeled for the simulator UI.
     *
     * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
     * (empty for playground / failed-registration traces). Super-admin only; read-only.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
        | QueryFiltersByQueryKey<
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData,
            TInfinite,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters,
            PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError
          >
    ): number;
    schema: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema;
    types: {
      parameters: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters;
      data: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData;
      error: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError;
    };
  };
}
/**
 * @summary Simulate
 * @description Run a tool (or an ordered steps[] sequence sharing ONE SimulationContext) for an
 * office, read-only/dry-run, and return the per-step decision trace + route funnel.
 */
export const simulateAdminSimulatorSimulatePost = {
  schema: {
    method: 'post',
    url: '/admin/simulator/simulate',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SimulateAdminSimulatorSimulatePostSchema;
  [QraftServiceOperationsToken]: SimulatorService['simulateAdminSimulatorSimulatePost'];
};
/**
 * @summary Office Profile
 * @description Read-only office availability profile (DB knobs + region/tech summary + code knobs).
 */
export const officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/office/{office_id}/profile',
    security: ['HTTPBearer'],
  },
} as {
  schema: OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet'];
};
/**
 * @summary Replay Call
 * @description Load a recorded call's tool sequence (for replay under current clock + data).
 */
export const replayCallAdminSimulatorSimulateReplayCallIdGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/replay/{call_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['replayCallAdminSimulatorSimulateReplayCallIdGet'];
};
/**
 * @summary Office Customers
 * @description Search customers WITHIN the chosen office, for the Run-as-call customer picker.
 *
 * Office-parameterized (the shared ``/customers/search`` scopes to the caller's own
 * office); super-admin only, like every simulator route. Read-only.
 */
export const officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/office/{office_id}/customers',
    security: ['HTTPBearer'],
  },
} as {
  schema: OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet'];
};
/**
 * @summary Office Service Types
 * @description Bookable services for the dependent service-type picker: the office's active
 * service-type templates (the voice catalog) + the customer's own service types.
 * Super-admin only; read-only.
 */
export const officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/office/{office_id}/service-types',
    security: ['HTTPBearer'],
  },
} as {
  schema: OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet'];
};
/**
 * @summary Persisted Traces
 * @description List the office's persisted live-call traces (FEAT-029), newest first.
 *
 * Not just the zero-slot calls: a returned-slots trace is equally inspectable (which
 * techs/routes were dropped despite an offer). Super-admin only; read-only.
 */
export const persistedTracesAdminSimulatorSimulateTracesGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/traces',
    security: ['HTTPBearer'],
  },
} as {
  schema: PersistedTracesAdminSimulatorSimulateTracesGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['persistedTracesAdminSimulatorSimulateTracesGet'];
};
/**
 * @summary Persisted Trace Detail
 * @description One persisted trace with its full decision path, labeled for the simulator UI.
 *
 * ``step.args`` are the recorded tool arguments from the linked CallToolExecution
 * (empty for playground / failed-registration traces). Super-admin only; read-only.
 */
export const persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet = {
  schema: {
    method: 'get',
    url: '/admin/simulator/simulate/traces/{trace_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema;
  [QraftServiceOperationsToken]: SimulatorService['persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet'];
};
export const simulatorService = {
  simulateAdminSimulatorSimulatePost,
  officeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGet,
  replayCallAdminSimulatorSimulateReplayCallIdGet,
  officeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGet,
  officeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGet,
  persistedTracesAdminSimulatorSimulateTracesGet,
  persistedTraceDetailAdminSimulatorSimulateTracesTraceIdGet,
} as const;
type SimulateAdminSimulatorSimulatePostSchema = {
  method: 'post';
  url: '/admin/simulator/simulate';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SimulateAdminSimulatorSimulatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SimulateAdminSimulatorSimulatePostData =
  paths['/admin/simulator/simulate']['post']['responses']['200']['content']['application/json'];
type SimulateAdminSimulatorSimulatePostError =
  paths['/admin/simulator/simulate']['post']['responses']['422']['content']['application/json'];
type SimulateAdminSimulatorSimulatePostBody =
  paths['/admin/simulator/simulate']['post']['requestBody']['content']['application/json'];
type OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/office/{office_id}/profile';
  security: ['HTTPBearer'];
};
type OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetParameters =
  paths['/admin/simulator/simulate/office/{office_id}/profile']['get']['parameters'];
type OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetData =
  paths['/admin/simulator/simulate/office/{office_id}/profile']['get']['responses']['200']['content']['application/json'];
type OfficeProfileAdminSimulatorSimulateOfficeOfficeIdProfileGetError =
  paths['/admin/simulator/simulate/office/{office_id}/profile']['get']['responses']['422']['content']['application/json'];
type ReplayCallAdminSimulatorSimulateReplayCallIdGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/replay/{call_id}';
  security: ['HTTPBearer'];
};
type ReplayCallAdminSimulatorSimulateReplayCallIdGetParameters =
  paths['/admin/simulator/simulate/replay/{call_id}']['get']['parameters'];
type ReplayCallAdminSimulatorSimulateReplayCallIdGetData =
  paths['/admin/simulator/simulate/replay/{call_id}']['get']['responses']['200']['content']['application/json'];
type ReplayCallAdminSimulatorSimulateReplayCallIdGetError =
  paths['/admin/simulator/simulate/replay/{call_id}']['get']['responses']['422']['content']['application/json'];
type OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/office/{office_id}/customers';
  security: ['HTTPBearer'];
};
type OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetParameters =
  paths['/admin/simulator/simulate/office/{office_id}/customers']['get']['parameters'];
type OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetData =
  paths['/admin/simulator/simulate/office/{office_id}/customers']['get']['responses']['200']['content']['application/json'];
type OfficeCustomersAdminSimulatorSimulateOfficeOfficeIdCustomersGetError =
  paths['/admin/simulator/simulate/office/{office_id}/customers']['get']['responses']['422']['content']['application/json'];
type OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/office/{office_id}/service-types';
  security: ['HTTPBearer'];
};
type OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetParameters =
  paths['/admin/simulator/simulate/office/{office_id}/service-types']['get']['parameters'];
type OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetData =
  paths['/admin/simulator/simulate/office/{office_id}/service-types']['get']['responses']['200']['content']['application/json'];
type OfficeServiceTypesAdminSimulatorSimulateOfficeOfficeIdServiceTypesGetError =
  paths['/admin/simulator/simulate/office/{office_id}/service-types']['get']['responses']['422']['content']['application/json'];
type PersistedTracesAdminSimulatorSimulateTracesGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/traces';
  security: ['HTTPBearer'];
};
type PersistedTracesAdminSimulatorSimulateTracesGetParameters =
  paths['/admin/simulator/simulate/traces']['get']['parameters'];
type PersistedTracesAdminSimulatorSimulateTracesGetData =
  paths['/admin/simulator/simulate/traces']['get']['responses']['200']['content']['application/json'];
type PersistedTracesAdminSimulatorSimulateTracesGetError =
  paths['/admin/simulator/simulate/traces']['get']['responses']['422']['content']['application/json'];
type PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetSchema = {
  method: 'get';
  url: '/admin/simulator/simulate/traces/{trace_id}';
  security: ['HTTPBearer'];
};
type PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetParameters =
  paths['/admin/simulator/simulate/traces/{trace_id}']['get']['parameters'];
type PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetData =
  paths['/admin/simulator/simulate/traces/{trace_id}']['get']['responses']['200']['content']['application/json'];
type PersistedTraceDetailAdminSimulatorSimulateTracesTraceIdGetError =
  paths['/admin/simulator/simulate/traces/{trace_id}']['get']['responses']['422']['content']['application/json'];
